import { Link } from 'react-router-dom';

const Footer = () => {
  const links = {
    Product: [
      { label: 'Features', to: '/' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'For Teams', to: '/corporate' },
      { label: 'Resources', to: '/resources' },
    ],
    Company: [
      { label: 'About', to: '/' },
      { label: 'Contact', href: 'mailto:support@soldigital.in' },
    ],
    Legal: [
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'Terms & Conditions', to: '/terms-conditions' },
      { label: 'Refund Policy', to: '/refund-policy' },
      { label: 'Shipping Policy', to: '/shipping-policy' },
    ],
  };

  return (
    <footer className="bg-[#0A0A0A] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-20">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-12 lg:gap-16">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-flex items-center gap-2 mb-6" data-testid="footer-logo">
              <div className="w-9 h-9 rounded-full bg-[#B8935A] flex items-center justify-center">
                <span className="text-black font-heading font-bold text-lg">S</span>
              </div>
              <span className="font-heading font-bold text-lg tracking-tight">Sol Digital</span>
            </Link>
            <p className="text-white/60 leading-relaxed max-w-sm mb-6">
              The digital business card, refined. Tap. Share. Connect. Grow.
            </p>
            <p className="text-xs text-white/40">
              © {new Date().getFullYear()} Sol Digital. All rights reserved.
            </p>
          </div>

          {Object.entries(links).map(([heading, items]) => (
            <div key={heading}>
              <h4 className="text-xs uppercase tracking-widest text-[#B8935A] font-semibold mb-4">
                {heading}
              </h4>
              <ul className="space-y-3">
                {items.map((l) => (
                  <li key={l.label}>
                    {l.href ? (
                      <a href={l.href} className="text-sm text-white/70 hover:text-white transition-colors">
                        {l.label}
                      </a>
                    ) : (
                      <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors">
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">Made with care in India.</p>
          <p className="text-xs text-white/40">support@soldigital.in</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
